/**
 * Shopify Pagination Fix for monkeypen.com
 * 
 * This script fixes the issue with unwanted phcursor parameters in pagination URLs
 * on the /collections/all page. It intercepts clicks on pagination links and
 * rewrites the URLs to only include the page parameter.
 */

// Function to fix pagination links on the /collections/all page
function fixShopifyPagination() {
  // Only apply the fix on the collections/all page
  if (window.location.pathname.includes('/collections/all')) {
    // Find all pagination links
    const paginationLinks = document.querySelectorAll('.pagination a');
    console.log('Found pagination links to fix:', paginationLinks.length);
    
    // Modify each pagination link
    paginationLinks.forEach(link => {
      // Store the original click handler if it exists
      const originalOnClick = link.onclick;
      
      // Override the click event
      link.onclick = function(e) {
        // Prevent the default action
        e.preventDefault();
        
        // Get the href attribute
        let href = link.getAttribute('href');
        
        // Check if the URL contains phcursor parameter
        if (href.includes('phcursor=')) {
          // Extract just the page parameter
          const pageMatch = href.match(/[?&]page=(\d+)/);
          if (pageMatch && pageMatch[1]) {
            const pageNum = pageMatch[1];
            // Create a clean URL with just the page parameter
            href = '/collections/all?page=' + pageNum;
            console.log('Fixed pagination URL:', href);
          }
        }
        
        // Navigate to the clean URL
        window.location.href = href;
        
        return false;
      };
    });
    
    console.log('Pagination links have been fixed');
  }
}

// Execute the fix when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', fixShopifyPagination);

// Also run the fix now in case the DOM is already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  fixShopifyPagination();
}
